import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 換頁時自動捲回頁面頂端。
 *
 * SPA 用 React Router 切換路由不會重新載入頁面，捲動位置會停在上一頁的位置；
 * 點 logo、分類、任何連結到新頁時，使用者會發現畫面停在中間 — 體驗差。
 * 這個元件監聽 pathname 變化，每次換頁就捲到最上面。
 *
 * 放在 <Router> 內、<Routes> 之前，涵蓋全站（含巢狀路由）。
 * 用 pathname（不含 search）當依賴：同頁切換查詢字串（如 /shop?category=...）也算換內容，一併捲頂。
 */
function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}

export default ScrollToTop;
